import { getLifeAreaGoalIds } from '@griply/utils';
import { ID } from 'shared/types/id';

export const getHiddenLifeAreaGoalIds = (
  hiddenLifeAreaIds: ID[],
  lifeAreaGoalIdsMap?: Map<ID, ID[]>,
): Set<ID> =>
  new Set(getLifeAreaGoalIds(hiddenLifeAreaIds, lifeAreaGoalIdsMap));
